var components
try {
  components = {
    zPaging: function () {
      return import(
        /* webpackChunkName: "uni_modules/z-paging/components/z-paging/z-paging" */ "@/uni_modules/z-paging/components/z-paging/z-paging.vue"
      )
    },
    uCollapse: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-collapse/u-collapse" */ "uview-ui/components/u-collapse/u-collapse.vue"
      )
    },
    uCollapseItem: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-collapse-item/u-collapse-item" */ "uview-ui/components/u-collapse-item/u-collapse-item.vue"
      )
    },
    uLineProgress: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-line-progress/u-line-progress" */ "uview-ui/components/u-line-progress/u-line-progress.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l1 = _vm.__map(_vm.chapters, function (item, __i0__) {
    var $orig = _vm.__get_orig(item)
    var g0 = item.videos.length
    var l0 =
      g0 > 0
        ? _vm.__map(item.videos, function (sec, index) {
            var $orig = _vm.__get_orig(sec)
            var m0 = _vm.showNumber(sec)
            var g1 = sec.history.length
            var g2 = sec.questions.length
            var g3 = sec.questions.length
            var m1 = g3 > 0 ? _vm.checkShow(sec) : null
            var m2 = g3 > 0 ? _vm.doExamShow(sec) : null
            return {
              $orig: $orig,
              m0: m0,
              g1: g1,
              g2: g2,
              g3: g3,
              m1: m1,
              m2: m2,
            }
          })
        : null
    return {
      $orig: $orig,
      g0: g0,
      l0: l0,
    }
  })
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l1: l1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }